{
  "back_home": "返回首页",
  "error_403_subtitle": "抱歉，您无权访问此功能。",
  "error_404_subtitle": "抱歉，您访问的页面不存在。",
  "error_boundary_title": "页面加载失败",
  "error_boundary_subtitle": "请刷新页面重试",
  "user_center": "个人中心",
  "logout": "退出登录",
  "logout_confirm": "您确定要退出登录？",
  "please_login": "请登录",
  "menu_search_title": "搜索菜单",
  "menu_search_placeholder": "输入菜单名称",
  "menu_search_empty": "未找到匹配菜单",
  "menu_search_shortcut_hint": "搜索菜单（{{shortcut}}）",
  "advanced_filter": "高级筛选",
  "filter_count": "{{count}} 项",
  "btn_add": "添加",
  "btn_delete": "删除",
  "btn_delete_confirm_title": "确定要删除吗？",
  "btn_delete_confirm_content": "此操作将删除数据，请谨慎操作。",
  "btn_import": "导入",
  "btn_export": "导出",
  "btn_search": "查询",
  "btn_reset": "重置",
  "btn_save": "保存",
  "btn_cancel": "取消",
  "btn_copy": "复制",
  "btn_paste": "粘贴"
}
